/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template lang="pug">
    div(v-bind:class="['forgot-password-section', amplifyUI.formSection]" v-bind:data-test="auth.forgotPassword.section")
      div(v-bind:class="amplifyUI.sectionHeader" v-bind:data-test="auth.forgotPassword.headerSection") {{options.header}}
      div(v-bind:class="['forgot-password-body-section', amplifyUI.sectionBody]" v-bind:data-test="auth.forgotPassword.bodySection")
        div(v-bind:class="amplifyUI.formField")
          div(v-bind:class="amplifyUI.inputLabel") {{$Amplify.I18n.get('Username')}} *
          input(v-bind:class="amplifyUI.input" v-model="username" :placeholder="$Amplify.I18n.get('Enter your username')" autofocus="" v-bind:data-test="auth.forgotPassword.usernameInput")
        div(v-bind:class="amplifyUI.formField" v-if="sent")
          div(v-bind:class="amplifyUI.inputLabel") {{$Amplify.I18n.get('Code')}} *
          input(v-bind:class="amplifyUI.input" v-model="code" :placeholder="$Amplify.I18n.get('Code')" autofocus="" v-bind:data-test="auth.forgotPassword.codeInput")
        div(v-bind:class="amplifyUI.formField" v-if="sent")
          div(v-bind:class="amplifyUI.inputLabel") {{$Amplify.I18n.get('New Password')}} *
          password(v-bind:class="amplifyUI.input" v-model="password" type="password" v-bind:data-test="auth.forgotPassword.newPasswordInput" :placeholder="$Amplify.I18n.get('New Password')" autofocus="" :secure-length="8" :toggle="false")
      div(v-bind:class="amplifyUI.sectionFooter")
        span(v-bind:class="amplifyUI.sectionFooterPrimaryContent")
          button(v-if="!sent" v-bind:class="amplifyUI.button" v-on:click="submit" :disabled="!username" v-bind:data-test="auth.forgotPassword.sendCodeButton")
            geno-spinner(:loading="flow" :text="$Amplify.I18n.get('Send Code')" :size="32")
          button(v-if="sent" v-bind:class="amplifyUI.button" v-on:click="verify" :disabled="!username" v-bind:data-test="auth.forgotPassword.submitButton")
            geno-spinner(:loading="flow" :text="$Amplify.I18n.get('Submit')" :size="32")
        span(v-bind:class="amplifyUI.sectionFooterSecondaryContent")
          a(v-if="!sent" v-bind:class="amplifyUI.a" v-on:click="signIn" v-bind:data-test="auth.forgotPassword.backToSignInLink") {{$Amplify.I18n.get('Back to Sign In')}}
          a(v-if="sent" v-bind:class="amplifyUI.a" v-on:click="submit" v-bind:data-test="auth.forgotPassword.resentCodeLink") {{$Amplify.I18n.get('Resend Code')}}
      .error(v-if="error")
        | {{ error }}
      div.bottom(v-bind:class="amplifyUI.sectionHeader" v-bind:data-test="auth.forgotPassword.headerSection") 
      //div(v-bind:class="['forgot-password-body-section', amplifyUI.sectionBody]" v-bind:data-test="auth.forgotPassword.bodySection")
        div(v-bind:class="amplifyUI.formField")
          div(v-bind:class="amplifyUI.inputLabel") {{$Amplify.I18n.get('Email')}}
          input(v-bind:class="amplifyUI.input" v-model="email" :placeholder="$Amplify.I18n.get('Enter your email')" autofocus="" v-bind:data-test="auth.signUp.nonPhoneNumberInput")
      //div(v-bind:class="amplifyUI.sectionFooter")
        span(v-bind:class="amplifyUI.sectionFooterPrimaryContent")
          button(v-if="!sent" v-bind:class="amplifyUI.button" v-on:click="send" :disabled="!email" v-bind:data-test="auth.forgotPassword.sendCodeButton")
            geno-spinner(:loading="flow2" :text="$Amplify.I18n.get('Send Username')" :size="32")
</template>

<script>
// <input v-bind:class="amplifyUI.input" v-model="password" type="password" :placeholder="$Amplify.I18n.get('New Password')" autofocus v-bind:data-test="auth.forgotPassword.newPasswordInput" />
import AmplifyEventBus from '../../events/AmplifyEventBus';
import * as AmplifyUI from '@aws-amplify/ui';
import { auth } from '../../assets/data-test-attributes';
const Password = () => import('@/components/PasswordStrengthMeter.vue')

export default {
  name: 'ForgotPassword',
  props: ['forgotPasswordConfig'],
  components: { Password },
  data () {
    return {
        username: '',
        flow: false,
        flow2: false,
        code: '',
        password: '',
				email: '',
        error: '',
        sent: false,
        logger: {},
        amplifyUI: AmplifyUI,
        auth
    }
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get('Reset your password'),
        recover: this.$Amplify.I18n.get('Recover your username'),
      }
      return Object.assign(defaults, this.forgotPasswordConfig || {})
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name)
  },
  methods: {
		send: function() {},
    submit: function() {
      this.flow = true;
      this.$Amplify.Auth.forgotPassword(this.username)
        .then(() => {
      this.flow = false;
          this.sent = true;
          this.error = "passwords require uppercase letters, lowercase letters plus a special character, minimum length is 8";
          this.logger.info('forgotPassword success');
        })
        .catch(e => {
      this.flow = false;
        this.setError(e)
        });
    },
    verify: function() {
      this.flow = true;
      this.$Amplify.Auth.forgotPasswordSubmit(this.username, this.code, this.password)
        .then(() => {
      this.flow = false;
          this.logger.info('forgotPasswordSubmit success');
          AmplifyEventBus.$emit('authState', 'signIn');
        })
        .catch(e =>  {
      this.flow = false;
        this.setError(e)
        });
    },
    signIn: function() {
      AmplifyEventBus.$emit('authState', 'signIn');
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    }
  }
}
</script>
<style>
#auth > div > div.bottom.Section__sectionHeader___2djyg {
margin-top: 25px;
}
</style>
